"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSerie = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const Serie_1 = require("./Serie");
class MockSerie extends Serie_1.Serie {
    constructor(id) {
        super({});
        this.seriesType = echain_product_models_1.ArticleType.kette;
        this.id = id;
    }
    fromJson(json) {
        super.fromJson(json);
    }
    toJson() {
        return undefined;
    }
}
exports.MockSerie = MockSerie;
//# sourceMappingURL=MockSerie.js.map